import { find, findAll, register } from '../../../Javascript/Utils'

const component = el => {
  const componentPrefix = el.dataset.componentprefix
  const mobileMenu = find('#mobileMenu')
  const mobileMenuBtn = find('#mobileMenuBtn')
  const links = findAll(`.${componentPrefix}navigationLink`, el)
  const closeNav = find(`.${componentPrefix}closeNav`, el)

  links.forEach(link => {
    link.addEventListener('click', function (e) {
      mobileMenu.classList.remove(`${componentPrefix}-active`)
      document.firstElementChild.classList.remove('nav-open')
    })
  })

  mobileMenuBtn.addEventListener('click', function () {
    mobileMenu.classList.toggle(`${componentPrefix}-active`)
    document.firstElementChild.classList.toggle('nav-open')
  })

  closeNav.addEventListener('click', function () {
    mobileMenu.classList.remove(`${componentPrefix}-active`)
    document.firstElementChild.classList.remove('nav-open')
  })
}

register('mobileNav', component)
